const seoConfig = {
  sameAs: [
    'https://twitter.com/eenvandaag',
    'https://www.youtube.com/user/eenvandaag/',
    'https://www.instagram.com/eenvandaag/',
    'https://www.facebook.com/eenvandaag/',
  ],
  defaultImage: {
    src: '/assets/images/default-image.jpg',
    width: 1200,
    height: 630,
    type: 'image/jpeg',
    alt: 'EenVandaag',
  },
  logo: {
    src: '/assets/images/eenvandaag-logo.png',
    width: 512,
    height: 512,
  },
  title: 'EenVandaag',
  description:
    'EenVandaag is het nieuws- en actualiteitenprogramma van AVROTROS op NPO 1 en NPO Radio 1.',
  opinionPanelDescription:
    'Het EenVandaag Opiniepanel is een online onderzoekspanel waar 80.000 leden hun mening geven over actuele onderwerpen. Uitslagen zie je op tv, radio en online.',
  address: {
    addressCountry: 'NL',
    addressLocality: 'Hilversum',
    addressRegion: 'Noord-Holland',
    postalCode: '1217 AM',
    streetAddress: 'Witte Kruislaan 55',
  },
  searchAction: '/zoeken?q={search_term_string}',
  twitterAccount: 'eenvandaag',
  twitterCard: 'summary_large_image',
  author: 'EenVandaag',
  creator: 'AVROTROS',
  publisher: 'EenVandaag',
  themeColor: '#000836',
  robots:
    'index, follow, nocache, max-snippet:300, max-image-preview:large, max-video-preview:3', // Stichting OPR richtlijn.
  fbAppId: '355203504893114',
  link: [
    {
      rel: 'alternate',
      type: 'application/rss+xml',
      title: 'EenVandaag RSS',
      href: '/feed.rss',
    },
    {
      rel: 'shortcut icon',
      href: '/assets/favicon.ico',
      type: 'image/x-icon',
    },
    {
      rel: 'icon',
      sizes: '16x16',
      href: '/assets/favicon-16x16.png',
    },
    {
      rel: 'icon',
      sizes: '32x32',
      href: '/assets/favicon-32x32.png',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/assets/apple-touch-icon.png',
    },
    {
      rel: 'manifest',
      href: '/assets/site.webmanifest',
    },
  ],
};

export default seoConfig;
